import React, { FC } from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { withUserType } from '../withUserType';

// Role-prefixed shell: the same surface is mounted at /buyer/requestsToAdd and
// /supplier/requestsToAdd (internal service teams).
const RequestsToAddPage: FC<any> = ({ childRoutes, userType }): React.ReactElement => (
	<div>
		<Route
			path={`/${userType}/requestsToAdd`}
			exact={true}
			render={() => (
				<Redirect
					to={{
						pathname: `/${userType}/requestsToAdd/overview`,
					}}
				/>
			)}
		/>
		{childRoutes.map((route, index) => (
			<RouteWithSubRoutes key={index} {...route} />
		))}
	</div>
);

export default withUserType(RequestsToAddPage);
